import { Injectable } from '@angular/core';
import { ApiService } from './../services/api-service/api-service';

@Injectable()
export class NvTooltipDataService {
  constructor(private apiService: ApiService) {}

  getAsyncTooltip({ schoolId, shelterId, docId, calc }) {
    const validatedSchoolId = schoolId ? `schoolId: "${schoolId}", ` : '';
    const validatedShelterId = shelterId ? `shelterId: "${shelterId}", ` : '';
    const validatedDocId = docId && docId.docId ? docId.docId : docId;
    const query = `{
      Tooltip(
        ${validatedSchoolId}
        ${validatedShelterId}
        id: "${validatedDocId}",
        calc: "${calc}"
      ) {
          content {
            ... on TableTooltip{
              tableContent{
                rowData
                headers
              }
            }
          }
        }
      }`;

    const queryPayload = {
      query,
      fetchPolicy: 'no-cache',
    };

    return this.apiService.getStudentsGraphQL(queryPayload);
  }
}
